import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const Card = styled.div`
  width: "100%";
  min-height: 300px;
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(147, 141, 141, 0.15);
  border-radius: 0.25rem;
`;

const Title = styled.h3`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  font-fmaily: Open sans, sans-serif;
  color: #000000;
`;

const SpeakerBio = styled.p`
  margin-top: 4px;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #808080;
`;

const ActionButton = styled.button`
  background: transparent;
  color: #336cdb;
  font-size: 0.625rem;
`;

const Bubble = styled.div`
  color: #000;
  background: #fff;
  border-radius: 4px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 50px;
  width: 50px;
`;

const EventCard = ({
  id,
  title,
  speaker_name,
  image,
  date,
  num_attendees,
  credentials,
  openDialog,
  openNotifDialog,
}) => {
  const history = useHistory();
  return (
    <Card>
      <div
        className="px-4 py-4 w-full h-48 justify-between rounded rounded-b-none"
        style={{
          backgroundSize: "cover",
          backgroundImage: `url(${image})`,
        }}
      >
        <Bubble>
          <div className="text-sm text-center">{date}</div>
        </Bubble>
      </div>
      <div className="px-4 py-4">
        <Title>{title}</Title>
        <SpeakerBio>
          {speaker_name} {credentials}
        </SpeakerBio>
        <div className="mt-6 py-2">
          <p className="text-sm">{num_attendees} Attending</p>
        </div>
        <div className="flex justify-between">
          <ActionButton
            onClick={() => {
              openDialog(id, title);
            }}
          >
            View Respondents
          </ActionButton>
          <ActionButton
            onClick={() => {
              openNotifDialog(id, title);
            }}
          >
            Invite
          </ActionButton>
          <ActionButton
            onClick={() => {
              history.push("/add-event", [{ eventId: id }]);
            }}
          >
            Edit
          </ActionButton>
        </div>
      </div>
    </Card>
  );
};

export default EventCard;
